import { MapTo } from '@adobe/aem-react-editable-components';
import ProductPageRecommendedCard, { ProductPageRecommendedCardEditConfig } from './ProductPageRecommendedCard';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-page-recommended-card')(ProductPageRecommendedCard, ProductPageRecommendedCardEditConfig);